import { sdk } from 'src/utilities/sdk';
import { ILocation } from 'src/types/Location';

export const getLocationUrl = (corpId: string, locationId: string): string =>
  `/corp-admin/${corpId}/locations/${locationId}`;

export const getLocation = async (
  corpId: string,
  locationId: string
): Promise<ILocation> => {
  return sdk.http.get(getLocationUrl(corpId, locationId));
};
